import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Spin } from 'antd';

import AppLayout from '../layouts/AppLayout';

import Homepage from '../pages/Homepage';
import CampaignListings from '../pages/Campaign/CampaignListings';
import CampaignDetails from '../pages/Campaign/CampaignDetails';
import DetailsList from '../pages/DetailsList';
import DonateMoney from '../pages/DonateMoney';
import BlogDetails from '../pages/Blogs/BlogDetails';
import Blogs from '../pages/Blogs/Blogs';
import SubCategoryDetails from '../pages/Category/SubCategoryDetails';
import CategoryListing from '../pages/Category/CategoryListing';
import SubCategory from '../pages/Category/SubCategory';
import OtherCategory from '../pages/Category/OtherCategory';
import EventManager from '../pages/Events/EventManager';
import About from '../pages/About';
import ContactUs from '../pages/ContactUs';
import Guarantee from '../pages/Guarantee';
import School from '../pages/School/School';
import SchoolDetails from '../pages/School/SchoolDetails';
import SchoolDonate from '../pages/School/SchoolDonate';
import CharityDetails from '../pages/Charity/CharityDetails';
import CommunityDetail from '../pages/Community/CommunityDetail';
import OrganizationDetail from '../pages/Organization/OrganizationDetail';
import WhyIcause from '../pages/WhyIcause';
import Faq from '../pages/Faq';
import News from '../pages/News';
import NewsDetail from '../pages/NewsDetail';
import Security from '../pages/Security';
import BecomeApartner from '../pages/BecomeApartner';
import BecomeAnInvestor from '../pages/BecomeAnInvestor';
import Career from '../pages/Career';
import EventDetails from '../pages/EventDetails';
import SchoolListing from '../pages/School/SchoolListing';
import Organization from '../pages/Organization/Organization';
import OrganizationListing from '../pages/Organization/OrganizationListing';
import OrganizationDonate from '../pages/Organization/OrganizationDonate';
import Charity from '../pages/Charity/Charity';
import CharityListing from '../pages/Charity/CharityListing';
import Community from '../pages/Community/Community';
import CommunityListing from '../pages/Community/CommunityListing';
import CharityDonate from '../pages/Charity/CharityDonate';
import CommunityDonate from '../pages/Community/CommunityDonate';


import Loader from '../components/customComponents/Loader';

import * as actions from '../actions/user';


const ContainerRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    <Component {...props} />
  )} />
);

const AppRoute = (props) => {
  const { user, getUser, history } = props;
  const [loadingForFetchingUser, setLoadingForFetchingUser] = useState(false);
  const [authToken,] = useState(localStorage.getItem('loginToken'));
  
  useEffect(() => {
    if (authToken && (!user || !user.id)) {
      setLoadingForFetchingUser(true);
      getUser(authToken)
        .then(() => setLoadingForFetchingUser(false))
        .catch(() => setLoadingForFetchingUser(false))
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  if (loadingForFetchingUser) {
    return (<Spin tip="Please Wait" spinning={true} indicator={Loader} style={{ 'marginTop': '20%' }}> </Spin>);
  }
  return (
    <AppLayout history={history}>
      <Switch>
        <Route exact path="/">
          <Redirect to="/homepage" />
        </Route>
        <ContainerRoute path='/homepage' history={history} component={Homepage} />
        <ContainerRoute path='/news' history={history} component={News} />
        <ContainerRoute path='/news-detail/:id' history={history} component={NewsDetail} />
        <ContainerRoute path='/security' history={history} component={Security} />
        <ContainerRoute path='/faq' history={history} component={Faq} />
        <ContainerRoute path='/campaigns' history={history} component={CampaignListings} />
        <ContainerRoute path='/details' history={history} user={user} component={DetailsList} />
        <ContainerRoute path='/campaign-details/:id' history={history} user={user} component={CampaignDetails} />
        <ContainerRoute path='/donate-money/:id' history={history} user={user} component={DonateMoney} />
        <ContainerRoute path='/blog-details/:id' history={history} user={user} component={BlogDetails} />
        <ContainerRoute path='/blogs' history={history} user={user} component={Blogs} />
        <ContainerRoute path='/category/:id' history={history} user={user} component={SubCategory} />
        <ContainerRoute path='/starting_fund' history={history} user={user} component={CategoryListing} />
        {/* <ContainerRoute path='/details-four' history={history} user={user} component={DetailsFour} /> */}
        <ContainerRoute path='/event-manager' history={history} user={user} component={EventManager} />
        <ContainerRoute path='/about' history={history} user={user} component={About} />
        <ContainerRoute path='/contact-us' history={history} user={user} component={ContactUs} />
        <ContainerRoute path='/school' history={history} user={user} component={School} />
        <ContainerRoute path='/school-donate/:id' history={history} user={user} component={SchoolDonate} />
        <ContainerRoute path='/school-details/:id' history={history} user={user} component={SchoolDetails} />
        <ContainerRoute path='/charity-details/:id' history={history} user={user} component={CharityDetails} />
        <ContainerRoute path='/community-details/:id' history={history} user={user} component={CommunityDetail} />
        <ContainerRoute path='/organization-details/:id' history={history} user={user} component={OrganizationDetail} />
        <ContainerRoute path='/guarantee' history={history} user={user} component={Guarantee} />
        <ContainerRoute path='/why-icause' history={history} user={user} component={WhyIcause} />
        <ContainerRoute path='/become-a-partner' history={history} user={user} component={BecomeApartner} />
        <ContainerRoute path='/sub-category/:id' history={history} user={user} component={SubCategoryDetails} />
        <ContainerRoute path='/other-category/:id' history={history} user={user} component={OtherCategory} />
        <ContainerRoute path='/become-investor' history={history} user={user} component={BecomeAnInvestor} />
        <ContainerRoute path='/career' history={history} user={user} component={Career} />
        <ContainerRoute path='/event-details/:id' history={history} user={user} component={EventDetails} />
        <ContainerRoute path='/school-listing' history={history} user={user} component={SchoolListing} />
        <ContainerRoute path='/organization' history={history} user={user} component={Organization} />
        <ContainerRoute path='/organization-listing' history={history} user={user} component={OrganizationListing} />
        <ContainerRoute path='/organization-donate/:id' history={history} user={user} component={OrganizationDonate} />
        <ContainerRoute path='/charity' history={history} user={user} component={Charity} />
        <ContainerRoute path='/charity-listing' history={history} user={user} component={CharityListing} />
        <ContainerRoute path='/charity-donate/:id' history={history} user={user} component={CharityDonate} />
        <ContainerRoute path='/community' history={history} user={user} component={Community} />
        <ContainerRoute path='/community-listing' history={history} user={user} component={CommunityListing} />
        <ContainerRoute path='/community-donate/:id' history={history} user={user} component={CommunityDonate} />

        <Redirect from='*' to='/homepage' />
      </Switch>
    </AppLayout>
  );
}

export default connect(({ user }) => ({ user }), actions)(withRouter(AppRoute));
